import { NavLink } from 'react-router'
import { useAuth } from '../auth/AuthContext'
import { useI18n } from '../i18n'
import { LangSwitch } from './LangSwitch'
import { ThemeToggle } from './ThemeToggle'
import './AppNav.css'

export function AppNav() {
  const { user, signOut } = useAuth()
  const { t } = useI18n()

  return (
    <header className="app-nav">
      <div className="app-nav-brand">{t('common.appName')}</div>
      <nav className="app-nav-links">
        <NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'active' : '')}>
          {t('nav.dashboard')}
        </NavLink>
        <NavLink to="/saved" className={({ isActive }) => (isActive ? 'active' : '')}>
          {t('nav.saved')}
        </NavLink>
        <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')}>
          {t('nav.profile')}
        </NavLink>
      </nav>
      <div className="app-nav-actions">
        <LangSwitch />
        <ThemeToggle />
        {user && (
          <button type="button" className="btn btn-ghost" onClick={signOut}>
            {t('common.signOut')}
          </button>
        )}
      </div>
    </header>
  )
}
